__turbopack_context__.v({
  "jetDetails": "jetDetails-module-scss-module__BqHJma__jetDetails",
  "jetDetailsContent": "jetDetails-module-scss-module__BqHJma__jetDetailsContent",
  "jetDetailsLine": "jetDetails-module-scss-module__BqHJma__jetDetailsLine",
  "jetDetailsLineItems": "jetDetails-module-scss-module__BqHJma__jetDetailsLineItems",
  "jetDetailsLineMaineTitle": "jetDetails-module-scss-module__BqHJma__jetDetailsLineMaineTitle",
  "jetDetailsLineTitle": "jetDetails-module-scss-module__BqHJma__jetDetailsLineTitle",
  "jetDetailsLineValue": "jetDetails-module-scss-module__BqHJma__jetDetailsLineValue",
  "jetDetailsTitle": "jetDetails-module-scss-module__BqHJma__jetDetailsTitle",
});
